module.exports = __webpack_public_path__ + "img/744.a5479173.jpg";